import { AppDate } from '../envTypes';

import { ModelBase } from './base';
import { Profile } from './profile';

// Use type import to avoid circular dependency
import type { StoreFront } from './store';

export enum BadgeStatus {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  EDIT_REQUIRE = 'EDIT_REQUIRE',
}

export enum BadgeCreateStep {
  FILL_BASE_INFO = 'FILL_BASE_INFO',
  UPLOAD_BADGE = 'UPLOAD_BADGE',
  CONFIRM_BADGE = 'CONFIRM_BADGE',
  REVIEW_BADGE = 'REVIEW_BADGE',
}

export enum BadgeLimit {
  Badge_LIMIT_5 = 'Badge_LIMIT_5',
  Badge_LIMIT_25 = 'Badge_LIMIT_25',
  Badge_LIMIT_100 = 'Badge_LIMIT_100',
  Badge_LIMIT_250 = 'Badge_LIMIT_250',
  Badge_LIMIT_500 = 'Badge_LIMIT_500',
  Badge_LIMIT_1000 = 'Badge_LIMIT_1000',
  Unlimited = 'Unlimited',
}

export interface Badge extends ModelBase {
  status: BadgeStatus;
  approvedById?: string;
  approvedAt?: AppDate;
  name: string;
  description: string;
  currentStep: BadgeCreateStep;
  generatedAt?: AppDate;
  storeId: string;
  store: StoreFront;
  assignedCount: number;
  limitCount: number;
  limit: BadgeLimit;
  url?: string;
  editionNoGaps?: string[];
  nextEditionNo: number;
}

export interface UserBadge extends ModelBase {
  earnedAt: AppDate;
  editionNo: string;
  storeId: string;
  badgeId: string;
  badge: Badge;
}

export interface BadgeUser extends ModelBase {
  earnedAt: AppDate;
  storeId: string;
  editionNo: string;
  badgeId: string;
  userId: string;
  profile: Profile;
}
